import React, { useContext, useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  Link,
  Box,
  Tooltip,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  Autocomplete,
  FormControl,
  TextField,
  MenuItem,
  InputLabel,
  Select,
  DialogTitle,
  Pagination,
} from "@mui/material";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import { IoMdCloseCircle } from "react-icons/io";

import { AiOutlineSelect } from "react-icons/ai";

import { IoEyeSharp } from "react-icons/io5";
import axios from "axios";
import ApiConfig from "../../Auth/ApiConfig";
import { AuthContext } from "../../Auth/context/Auth";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { BackHand } from "@mui/icons-material";
import toast from "react-hot-toast";
import ClaimCard from "../../Pages/ClaimCard";

export default function ClaimList() {
  const navigate = useNavigate();
  const location = useLocation();
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const isAdminPayment = location.pathname === "/payments";
  const [claimListing, setClaimListing] = useState([]);
  const [claimNo, setClaimNo] = useState("");
  const [status, setStatus] = useState("");

  const [open, setOpen] = useState(false);
  const [age, setAge] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [checked, setChecked] = useState(false);
  const [selectedClaimIds, setSelectedClaimIds] = useState([]);
  const [totalPages, setTotalPages] = useState("");
  const auth = useContext(AuthContext);
  const userData = auth.userData;
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  console.log("sadgfasdgfads", userData);

  // const handleSearchQueryChange = (e) => setSearchQuery(e.target.value);

  const staticClaims = [
    {
      created_at: "2024-04-01T10:30:00Z",
      full_name: "John Doe",
      claim_number: "CL123456",
      claim_amount: "$1,200",
      status: "pending",
    },
    {
      created_at: "2024-03-20T08:00:00Z",
      full_name: "Jane Smith",
      claim_number: "CL789101",
      claim_amount: "$950",
      status: "approved",
    },
    {
      created_at: "2024-02-10T15:45:00Z",
      full_name: "Alice Johnson",
      claim_number: "CL654321",
      claim_amount: "$700",
      status: "rejected",
    },
  ];
  const handleChangeIcon = () => {
    setChecked((prev) => !prev);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const claimListData = async () => {
    const token = window.localStorage.getItem("adminToken");
    setLoading(true);
    try {
      const response = await axios({
        method: "GET",
        url: ApiConfig.claimList,
        headers: {
          authorization: `Bearer ${token}`,
        },
        params: {
          page: page,
          limit: limit,
          q: searchQuery,
          // claimNumber: claimNo,
          status: status,
        },
      });
      if (response?.data?.success === true) {
        setClaimListing(response?.data?.data);
        setTotalPages(response?.data?.data[0]?.count);
      } else {
        setClaimListing([]);
      }
    } catch (error) {
      setClaimListing([]);
      console.log(error, "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    claimListData();
  }, [page, limit, searchQuery, claimNo, status]);

  const handleSearchQueryChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleChanges = (event, value) => {
    setSelectedItems(value);

    // Ensures all claim_numbers are strings
    const selectedIds = value?.map((item) => String(item?.claim_id));
    setSelectedClaimIds(selectedIds);

    console.log("Selected Claim Numbers:", selectedIds); // ["CL123456", "CL789101"]
  };
  const token = window.localStorage.getItem("adminToken");
  const selectData = async () => {
    try {
      const response = await axios({
        method: "PUT",
        url: ApiConfig.multiSelected,
        headers: {
          autorization: `Bearer ${token}`,
        },
        data: {
          claim_ids: selectedClaimIds,
          status: age,
        },
      });
      console.log("dataatatat", response);
      if (response?.data?.success === true) {
        setLoading(false);
        setOpen(false);
        toast.success(response.data.message);
      }
    } catch (error) {
      setOpen(false);
      setLoading(false);
      toast.error(error.response.data.message);

      console.log(error, "error");
    }
  };
  return (
    <>
      {["admin", "insurance"].includes(userData?.role) && (
        <ClaimCard />
      )}
      <Box
        sx={{
          height: "100vh",
          marginTop: { xs: "0px", md: "3rem" },
          background: "#F5F5F5",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-start", md: "center" },
            mb: 2,
            gap: 2,
          }}
        >
          {/* Title */}
          <Typography
            variant="h4"
            sx={{
              fontSize: "30px",
              fontWeight: "700",
              fontFamily: "rubik",
              mb: { xs: 1, md: 0 },
            }}
          >
            Claim List
          </Typography>

          {/* Filters */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              width: { xs: "100%", md: "auto" },
            }}
          >
            {/* Search */}
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search..."
              type="search"
              value={searchQuery}
              onChange={handleSearchQueryChange}
              fullWidth
              sx={{
                backgroundColor: "#fff",
                borderRadius: "8px",
                minWidth: { sm: 200 },
                "& .MuiOutlinedInput-root": {
                  paddingRight: 0,
                  padding: "2.5px 0px",
                  borderRadius: "10px",
                },
              }}
              InputProps={{ sx: { paddingRight: "8px" } }}
            />

            {/* Claim No */}
            {/* <TextField
              variant="outlined"
              size="small"
              placeholder="Claim No"
              value={claimNo}
              onChange={(e) => setClaimNo(e.target.value)}
              fullWidth
              sx={{
                backgroundColor: "#fff",
                borderRadius: "8px",
                minWidth: { sm: 150 },
                "& .MuiOutlinedInput-root": {
                  paddingRight: 0,
                  padding: "2.5px 0px",
                  borderRadius: "10px",
                },
              }}
            /> */}

            {/* Status */}
            <FormControl
              size="small"
              fullWidth
              sx={{
                minWidth: { sm: 150 },
                backgroundColor: "#fff",
                borderRadius: 2,
                height: 43,
                "& .MuiOutlinedInput-root": {
                  paddingRight: 0,
                  padding: "2.5px 0px",
                  borderRadius: "10px",
                },

              }}
            >
              <InputLabel>Status</InputLabel>
              <Select
                value={status}
                label="Status"
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="approved">Approved</MenuItem>
                <MenuItem value="pending">Pending</MenuItem>
                <MenuItem value="rejected">Rejected</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>

        {/* <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <Typography
          variant="h4"
          sx={{ fontSize: "30px", fontWeight: "700", fontFamily: "rubik" }}
        >
          Claim List
        </Typography>
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search..."
          type="search"
          value={searchQuery}
          onChange={handleSearchQueryChange}
          fullWidth
          sx={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            width: { xs: "auto", sm: "auto" },
            minWidth: { sm: 200 },
            "& .MuiOutlinedInput-root": {
              paddingRight: 0,
              padding: "2.5px 0px",
              borderRadius: "10px",
            },
          }}
          InputProps={{ sx: { paddingRight: "8px" } }}
        />
      </Box> */}

        <TableContainer
          component={Paper}
          elevation={3}
          sx={{
            height: "auto",
            background: "#fff",
            borderRadius: "10px",
            marginTop: "20px",
            width: { xs: "100% !important", md: "100% !important" },
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                {[
                  "Date",
                  "Full Name",
                  "Claim Number",
                  "Claim Amount",
                  "Claim Approved Amount",
                  "Status",
                  ...(userData?.role !== "hospital" ? ["Action"] : []),
                ].map((heading, i) => (
                  <TableCell
                    key={i}
                    sx={{ fontWeight: "bold", textAlign: "center",textWrap:'nowrap' }}
                  >
                    {heading}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell
                    colSpan={6}
                    align="center"
                    sx={{ borderBottom: "none" }}
                  >
                    <Box sx={{ py: 4 }}>
                      <CircularProgress />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : claimListing?.[0]?.rows?.length > 0 ? (
                claimListing?.[0]?.rows?.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                      borderRadius: "10px",
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell align="center">
                      {row?.created_at
                        ? moment(row.created_at).format("YYYY-MM-DD")
                        : "--"}
                    </TableCell>
                    <TableCell align="center">{row.full_name || "--"}</TableCell>
                    <TableCell align="center">
                      {row.claim_number || "--"}
                    </TableCell>
                    <TableCell align="center">
                      {row.claim_amount || "--"}
                    </TableCell>
                    <TableCell align="center">
                      {row.claim_approved_amount || "--"}
                    </TableCell>
                    <TableCell align="center">
                      {row?.status?.charAt(0).toUpperCase() +
                        row?.status?.slice(1)}
                    </TableCell>
                    <TableCell align="center">
                      {(userData?.role === "admin" ||
                        userData?.role === "insurance") && (
                          <IconButton>
                            {/* <AiOutlineSelect /> */}
                            {/* <CheckBoxOutlineBlankIcon
                      onChange={handleChange}
                      inputProps={{ 'aria-label': 'controlled' }}
                      /> */}
                          </IconButton>
                        )}
                      <Tooltip title={"View Claim"}>
                        <IconButton
                          onClick={() =>
                            navigate("/viewClaim", {
                              state: { row },
                            })
                          }
                        >
                          <IoEyeSharp />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={6}
                    align="center"
                    sx={{ borderBottom: "none" }}
                  >
                    <Box sx={{ py: 4 }}>No Data found</Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {totalPages > 1 && claimListing?.[0]?.rows?.length > 0 && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              // marginTop: "10px",
              padding: "20px",
              "& .Mui-selected": {
                backgroundColor: "#00b2ff !important",
                color: "#fff !important",
                borderRadius: "5px",
              },
              "& .MuiPaginationItem-root": { color: "black" },
            }}
          >
            <Pagination
              page={page}
              onChange={handlePageChange}
              count={totalPages}
            />
          </Box>
        )}

        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            sx: {
              padding: "1.5rem",
              borderRadius: "12px",
            },
          }}
        >
          <DialogTitle>
            {/* <Box sx={{display:'flex',justifyContent:'flex-end',marginTop:"-20px"}}>
          <IconButton>
            <IoMdCloseCircle size={40} />
          </IconButton>
          </Box> */}

            <Typography
              variant="h5"
              style={{ fontWeight: "600", fontSize: "19px" }}
            >
              Claim Select
            </Typography>
          </DialogTitle>
          <DialogContent>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-helper-label">Status</InputLabel>
              <Select
                labelId="demo-simple-select-helper-label"
                id="demo-simple-select-helper"
                value={age}
                fullWidth
                label="Status"
                onChange={handleChange}
              >
                <MenuItem value={"approved"}>Approved</MenuItem>
                <MenuItem value={"processing"}>Processing</MenuItem>
                <MenuItem value={"paid"}>Paid</MenuItem>
                <MenuItem value={"rejected"}>Rejected</MenuItem>
              </Select>
            </FormControl>
          </DialogContent>
          <DialogContent>
            <Autocomplete
              multiple
              fullWidth
              id="checkboxes-tags-demo"
              options={claimListing?.[0]?.rows}
              disableCloseOnSelect
              getOptionLabel={(option) => option.full_name ?? ""}
              onChange={handleChanges}
              renderOption={(props, option, { selected }) => {
                const { key, ...optionProps } = props;
                return (
                  <li key={key} {...optionProps}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.full_name ?? "Unnamed"}
                  </li>
                );
              }}
              style={{ width: 500 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Claims"
                  placeholder="Claim users"
                />
              )}
            />
          </DialogContent>

          <DialogActions>
            <Button
              onClick={handleClose}
              sx={{
                fontSize: "15px",
                textTransform: "capitalize",
                fontWeight: "500",
                width: "25%",
                borderRadius: "10px",
                background: "#03A7E5",
                border: "1px solid #03A7E5",
                color: "#fff",
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={selectData}
              autoFocus
              sx={{
                fontSize: "15px",
                textTransform: "capitalize",
                fontWeight: "500",
                width: "25%",
                borderRadius: "10px",
                background: "#03A7E5",
                border: "1px solid #03A7E5",
                color: "#fff",
              }}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
}
